
/**
 *
 * @param $osmMap {jQuery}
 * @param $markerPopUps {jQuery}
 * @constructor
 */
let OpenStreetMapVO = function ($osmMap, $markerPopUps) {
    this.$osmMap = $osmMap;
    this.$markerPopUps = $markerPopUps;
    this.mapHeight = 0;
    /** @type {string[]} */
    this.activeIDs = null;
    this.tileLayer = '';
    this.attribution = '';
    this.hideAttribution = false;
    this.clusterClassMedium = '';
    this.clusterClassLarge = '';
    this.clusterIconWidth = 0;
    this.clusterIconHeight = 0;
    this.largeBreakpoint = 0;
    this.maxClusterRadius = 0;
    /** @type {int|null} */
    this.disableClusteringAtZoom = null;
    /** @type {int|null} */
    this.defaultZoomLevel = null;
    this.fallbackZoomLevel = 1;
    this.boundsZoomPadding = 1;
    this.centreOnUser = false;
    this.defaultCentreLatLng  = new L.LatLng(0, 0)
    this.markerIcon = {
        iconUrl: '',
        iconSize:     [0, 0],
        iconAnchor:   [0, 0],
        popupAnchor:  [0, 0]
    }
    this.userMarkerIcon = {
        iconUrl: '',
        iconSize:     [0, 0],
        iconAnchor:   [0, 0],
        popupAnchor:  [0, 0]
    }
    this.userLatLng = new L.LatLng(0, 0)
}


/**
 *
 * @constructor
 */
let OpenStreetMapFunctions = function () {
    /** @type {function} */
    this.onFilterApplied = null;
    /** @type {function} */
    this.onUserLocationChanged = null;
    /** @type {function} */
    this.onShowMapClicked = null;
}


/**
 *
 * @param $osmMap {jQuery|JQuery}
 * @param $markerPopUps {jQuery|JQuery}
 * @returns {OpenStreetMapVO}
 */
let createDefaultOpenStreetVO = function ($osmMap, $markerPopUps) {

    //more styles here
    //http://leaflet-extras.github.io/leaflet-providers/preview/index.html

    let vo = new OpenStreetMapVO($osmMap, $markerPopUps);
    const defaultZoomLevel = parseInt($osmMap.data("zoom"));
    if(defaultZoomLevel){
        vo.defaultZoomLevel = defaultZoomLevel;
    }

    vo.mapHeight = 480;
    vo.tileLayer = 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
    //vo.tileLayer = 'http://{s}.tile.osm.org/{z}/{x}/{y}.png';
    vo.attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
    vo.hideAttribution = false;
    vo.clusterClassMedium = 'marker-cluster marker-cluster-medium';
    vo.clusterClassLarge = 'marker-cluster marker-cluster-large';
    vo.clusterIconWidth = 53;
    vo.clusterIconHeight = 53;
    vo.largeBreakpoint = 10;
    vo.maxClusterRadius = 40;
    vo.fallbackZoomLevel = 10;
    vo.recentreZoomAbove = 10;
    vo.markerIcon = {
        iconUrl: '/app/themes/hailstone/img/layout/home-icon.png',
        iconSize:     [32, 32],
        iconAnchor:   [16, 32],
        popupAnchor:  [0, -32]
    }

    vo.userMarkerIcon = {
        iconUrl: '/app/themes/hailstone/img/layout/user-icon.png',
        iconSize:     [32, 32],
        iconAnchor:   [16, 32],
        popupAnchor:  [0, -32]
    }

    return vo;
}

/**
 *
 * @param vo {OpenStreetMapVO}
 */
function determineUserLatLng(vo){

    let userLat = $("#user_set_lat").html();
    let userLng = $("#user_set_lng").html();

    if (!userLat || userLat === "" || userLat === undefined)
    {
        userLat = $("#user_lat").html();
        userLng = $("#user_lng").html();
    }
    vo.userLatLng.lat = userLat ? parseFloat(userLat) : 0;
    vo.userLatLng.lng = userLng ? parseFloat(userLng) : 0;
}


/**
 *
 * @param vo {OpenStreetMapVO}
 * @returns {OpenStreetMapFunctions}
 */
let createOpenStreetMap = function (vo) {
    let L = window.L;

    let functions = new OpenStreetMapFunctions()
    if(!vo.$osmMap.length){
        return functions;
    }
    /** @type {L.MarkerClusterGroup} */
    let markerClusterGroup; // cluster
    /** @type {L.Marker[]} */
    let addedMarkers = [];

    let map = null;
    let userMarker = null;

    function initMap () {


        if(vo.mapHeight){
            vo.$osmMap.height(vo.mapHeight);
        }

        let options = null;
        if(vo.hideAttribution){
            options = { attributionControl:false };
        }
        map = L.map(vo.$osmMap[0], options);

        L.tileLayer(vo.tileLayer, {
            attribution: vo.attribution
        }).addTo(map);
    }

    function addCluster()
    {
        markerClusterGroup = L.markerClusterGroup({
            maxClusterRadius: vo.maxClusterRadius,
            disableClusteringAtZoom: vo.disableClusteringAtZoom,
            animate: false,
            iconCreateFunction: function(cluster) {
                let clusterClass = vo.clusterClassMedium;
                if (cluster.getChildCount() >= vo.largeBreakpoint) {
                    clusterClass = vo.clusterClassLarge
                }
                return new L.DivIcon({
                    html: '<div><span>' + cluster.getChildCount() + '</span></div>',
                    className: clusterClass,
                    iconSize: new L.Point(vo.clusterIconWidth, vo.clusterIconHeight)
                });
            }
        });
        let markerIcon = L.icon(vo.markerIcon);

        addedMarkers.length = 0;
        vo.$markerPopUps.each(function (index, markerPopUp) {
            let $markerPopUp = $(markerPopUp);
            if($markerPopUp.data("lat") && $markerPopUp.data("lng")){
                let id = $markerPopUp.attr('id');
                let latLng = new L.LatLng(parseFloat($markerPopUp.data("lat")), parseFloat($markerPopUp.data("lng")))

                let title = $markerPopUp.data("title");
                let marker = L.marker(latLng, { icon: markerIcon, title: title })
                marker.info = {
                    id: id,
                    title: title
                }
                marker.bindPopup($markerPopUp[0]);
                markerClusterGroup.addLayer(marker);
                addedMarkers.push(marker);
            }
        })

        map.addLayer(markerClusterGroup);

        showActiveMarkers();
    }

    // loops through its markers and changes visibility for each to true or false
    function showActiveMarkers()
    {

        for(let i = 0; i < addedMarkers.length; i ++){
            let marker = addedMarkers[i];
            let visible = !vo.activeIDs || vo.activeIDs.includes(marker.info.id);
            if(visible){
                if(!markerClusterGroup.hasLayer(marker)){
                    markerClusterGroup.addLayer(marker);
                }
            } else {
                markerClusterGroup.removeLayer(marker)
            }
        }

    }

    function showUserPosition()
    {
        if(userMarker){
            map.removeLayer(userMarker);
        }
        if (!vo.userLatLng.lat || !vo.userLatLng.lng)
        {
            return
        }

        userMarker = L.marker(vo.userLatLng, { icon: L.icon(vo.userMarkerIcon)})
        map.addLayer(userMarker);
    }

    // self-explanatory, repositions map according to pins
    // but if we have a user pin, it becomes the center
    function centerMap()
    {

        let target = null;
        let bounds = new L.LatLngBounds();
        let pinCount = 0;

        for(let i = 0; i < addedMarkers.length; i ++){
            bounds.extend(addedMarkers[i]._latlng)
            pinCount ++;
        }

        if (vo.userLatLng.lat && vo.userLatLng.lng)
        {
            if(vo.centreOnUser){
                target = vo.userLatLng;
            }
            bounds.extend(vo.userLatLng)
            pinCount ++;
        }

        if(!target){
            target = bounds.getCenter();
        }
        let calculatedZoom = map.getZoom();
        const allowAnimations = !!calculatedZoom;

        if(calculatedZoom && vo.recentreZoomAbove && calculatedZoom > vo.recentreZoomAbove ){
            calculatedZoom = null;
        }
        if(!calculatedZoom){
            calculatedZoom = vo.defaultZoomLevel;
        }
        if(!calculatedZoom && pinCount < 2){
            calculatedZoom = vo.fallbackZoomLevel;
        }
        const latLng = vo.defaultCentreLatLng.lat && vo.defaultCentreLatLng.lng ? vo.defaultCentreLatLng : target;

        map.setView(latLng, calculatedZoom);

        if(!calculatedZoom){
            map.fitBounds(bounds, {animate: allowAnimations});
            map.setZoom(map.getZoom() - vo.boundsZoomPadding, {animate: allowAnimations})
        }

    }


    initMap();
    addCluster();
    centerMap();
    showUserPosition();

    functions.onFilterApplied = function () {
        showActiveMarkers();
    }
    functions.onUserLocationChanged = function () {
        showUserPosition();
        centerMap();
    }

    functions.onShowMapClicked = function () {
        map.invalidateSize();
        if(map.getZoom() === 0){
            centerMap();
        }
    }
    return functions;
}


/**
 *
 * @param lat {float}
 * @param lng {float}
 * @param callback {function(null|{city:string, town:string, village:string, region:string, state:string, county:string, postcode:string, countryCode:string, country:string})}
 */
let osmSearchLatLng = function (lat, lng, callback){
    $.get('https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat='+lat+'&lon='+lng, function(data){
        let address = data ? data.address : null;
        callback(address);
    });
}

/**
 *
 * @param searchValue {string}
 * @param callback {function(null|{lat: float, lng: float, display_name: string, address: {city:string, town:string, village:string, region:string, state:string, county:string, postcode:string, country_code:string, country:string}})}
 * @param requirements {{state:string, country_code:string}=}
 */
let osmSearchTownPostcode = function (searchValue, callback, requirements){
    searchValue = searchValue ? searchValue.trim() : null;
    if(!searchValue){
        callback(null);
        return;
    }
    requirements = requirements ? requirements : {};
    for(let key in requirements){
        requirements[key] = Array.isArray(requirements[key]) ? requirements[key] : [requirements[key]];
        for(let i = 0; i < requirements[key].length; i ++){
            requirements[key][i] = requirements[key][i].toLowerCase();
        }

    }

    const countryCodeRequirements = requirements.hasOwnProperty('country_code') ? (requirements.country_code ? requirements.country_code : []) : ['gb', 'ie'];
    const stateRequirements = requirements.state ? requirements.state : [];

    function callSearch(params, searchCallback){
        let query = 'format=jsonv2&addressdetails=1'
        for(let key in params){
            query += '&'+key+'='+encodeURIComponent(params[key].toLowerCase());
        }
        $.get('https://nominatim.openstreetmap.org/search?'+query, function(data){

            if(data){
                for(let i = 0; i < data.length; i ++){
                    let item = data[i];
                    let address = item.address;
                    if((!countryCodeRequirements.length || countryCodeRequirements.includes(address.country_code.toLowerCase())) && (!stateRequirements.length || stateRequirements.includes(address.state.toLowerCase()))){
                        callback(item);
                        return null;
                    }
                }
            }
            searchCallback(null);
        }).fail(function() {
            searchCallback(null)
        });
    }


    const searchBasicPostcode = () => {
        let noSpace = searchValue.split(" ")[0];
        if(!noSpace || noSpace === searchValue){
            callback(null)
            return;
        }
        callSearch({
            q: noSpace
        }, function (response) {
            callback(response)
        })
    }

    const searchPostcode = () => {
        callSearch({
            q: searchValue
        }, function (response) {
            if (response) {
                callback(response)
                return;
            }
            searchBasicPostcode();
        });
    }

    /**
     *
     * @param countryCodeIndex {int}
     */
    const searchCity = (countryCodeIndex) => {
        if(countryCodeIndex === countryCodeRequirements.length){
            searchPostcode();
            return;
        }
        const country = countryCodeRequirements[countryCodeIndex];
        callSearch({
            country: country,
            city: searchValue
        }, function (response) {
            if(response){
                callback(response)
                return;
            }
            searchCity(countryCodeIndex + 1);
        });
    }

    searchCity(0);
}